var map = {
	"./amex.png": 943,
	"./diners.png": 944,
	"./discover.png": 945,
	"./jcb.png": 946,
	"./maestro.png": 1169,
	"./mastercard.png": 947,
	"./stripe.png": 948,
	"./union.png": 949,
	"./unknown.png": 623,
	"./visa.png": 950
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1168;